import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Button } from 'antd'
import * as req from '../../common/requests'

import css from '../../common/Form.css'

export default class OrthoTracSync extends Component {
  static propTypes = {
    practiceId: PropTypes.string.isRequired,
  }

  state = {
    enterpriseId: null,
    error: false,
    loading: true,
    remoteDb: null,
  }

  componentWillMount() {
    const { practiceId } = this.props
    req.getRemoteDatabases(practiceId)
      .then((res) => {
        if (res.length) {
          const db = res[0]
          this.setState({
            enterpriseId: db.address,
            remoteDb: db,
            loading: false,
          })
        } else {
          this.setState({ loading: false })
        }
      })
      .catch(() => {
        this.setState({ loading: false, error: true })
      })
  }

  saveEnterpriseId = () => {
    const { practiceId } = this.props
    const { enterpriseId, remoteDb } = this.state
    let res
    const body = {
      practice_id: practiceId,
      address: enterpriseId,
    }
    if (remoteDb) {
      res = req.updateRemoteDatabase(practiceId, remoteDb.id, body)
    } else {
      res = req.createRemoteDatabase(practiceId, body)
    }

    res.catch(() => {
      this.setState({ error: true })
    })
  }

  changeEnterpiseId = (e) => {
    this.setState({ enterpriseId: e.target.value })
  }

  render() {
    const { enterpriseId, error, loading, remoteDb } = this.state
    const saveSuccess = remoteDb && remoteDb.address === enterpriseId
    const buttonText = saveSuccess ? 'Saved' : 'Save'

    return (
      <div>
        {error ? (
          <div> There was an error accessing the backend </div>
        ) : (
          <Form onSubmit={this.handleConnect}>
            <h3>OrthoTrac Sync</h3>
            <Form.Item label="Enterprise ID from Carestream">
              <Input
                placeholder=""
                value={enterpriseId}
                name="enterpriseId"
                className={css.input}
                onChange={this.changeEnterpiseId}
              />
            </Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              disabled={!enterpriseId}
              type={saveSuccess ? 'primary' : null}
              onClick={this.saveEnterpriseId}
            >
              {buttonText}
            </Button>
          </Form>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/OrthoTracSync.js